import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
import Source from "./Source";
/**
 * @classdesc OrientedImageSource is a specific source used to load oriented images.
 * @extends Source
 */

var OrientedImageSource =
/*#__PURE__*/
function (_Source) {
  _inherits(OrientedImageSource, _Source);

  /**
   * @constructor
   * @param { Object } source - Configuration object
   * @param { string } source.url - Url for all the textures.
   * This Url must contains {sensorId} and {cameraId}, and these pattern will be replaced to build the Url,
   * to find the good texture for each camera for each panoramic.
   */
  function OrientedImageSource(source) {
    var _this;

    _classCallCheck(this, OrientedImageSource);

    source.format = source.format || 'json';
    _this = _possibleConstructorReturn(this, _getPrototypeOf(OrientedImageSource).call(this, source));
    _this.isOrientedImageSource = true;
    return _this;
  }
  /**
   * Build the url of the texture, but not from extent.
   *
   * @param      {Object}  imageInfo - Information about the texture
   * @param      {string}  imageInfo.camera - Id of the camera
   * @param      {string}  imageInfo.pano - Id of the panoramic
   * @return     {string}  Url of the image
   */


  _createClass(OrientedImageSource, [{
    key: "urlFromExtent",
    value: function urlFromExtent(imageInfo) {
      return this.imageUrl(imageInfo.cameraId, imageInfo.panoId);
    }
    /**
     * Build the url of the image, for a given panoramic id, and a given camera id.
     *
     * @param      {string}  cameraId  Id of the camera
     * @param      {string}  panoId   Id of the panoramic
     * @return     {string}  Url of the image
     */

  }, {
    key: "imageUrl",
    value: function imageUrl(cameraId, panoId) {
      return this.url.replace('{cameraId}', cameraId).replace('{panoId}', panoId);
    }
  }]);

  return OrientedImageSource;
}(Source);

export default OrientedImageSource;